// extracted by mini-css-extract-plugin
module.exports = {"item":"hamburger-menu-item_item__on1MY","link":"hamburger-menu-item_link__ZBDXI","button":"hamburger-menu-item_button__K_N0y"};